import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Empowering from "./sections/Empowering";
import Commitment from "./sections/Commitment";
import Journey from "./sections/Journey";
import Excellence from "./sections/Excellence";
import Pathways from "./sections/Pathways";
import Impact from "./sections/Impact";
import JourneyCopy from "./sections/JourneyCopy";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      
      <Empowering />
      <Commitment />
      <Journey />
      <Excellence />
      
      <Impact />
      <JourneyCopy />
      <Footer />
    </div>;
}